import { __assign } from "tslib";
import * as React from 'react';
import { CustomizerContext, FocusRectsProvider, getNativeElementProps, omit } from '@fluentui/utilities';
import { ThemeContext } from './ThemeContext';
export var renderThemeProvider = function (state) {
    var customizerContext = state.customizerContext, ref = state.ref, theme = state.theme;
    var Root = state.as || 'div';
    var rootProps = typeof state.as === 'string'
        ? getNativeElementProps(state.as, state)
        : state.as === React.Fragment
            ? { children: state.children }
            : omit(state, ['as']);
    return (React.createElement(ThemeContext.Provider, { value: theme },
        React.createElement(CustomizerContext.Provider, { value: customizerContext },
            React.createElement(FocusRectsProvider, { providerRef: ref },
                React.createElement(Root, __assign({}, rootProps))))));
};
//# sourceMappingURL=renderThemeProvider.js.map